export default "__VITE_ASSET__BkpJTnon__"